module.exports = __webpack_public_path__ + "static/img/loading.9b6562b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/V2/svg/asset/loading.gif
// module id = OXs5
// module chunks = 0